<template>
    <div class="container">
        <LoadingBlock v-if="!hasBoilerModel && isLoading"/>
        <RouterView v-if="hasBoilerModel"/>
    </div>
</template>

<script>
import {mapGetters} from "vuex"
import LoadingBlock from "../../Common/UI/LoadingBlock.vue"

export default {

    components: {
        LoadingBlock,
    },

    computed: {
        ...mapGetters({
            isLoading: 'appliance/models/isLoading',
            hasBoilerModel: 'appliance/models/hasModel',
            boilerModel: 'appliance/models/getModel',
        }),
    },

    created() {
        this.$store.dispatch("appliance/models/clear")
        this.loadBoilerModel(this.$route.params.id)
    },

    methods: {

        loadBoilerModel(id) {
            this.$store.dispatch("appliance/models/getModel", id)
                .catch((error) => {
                    this.errorMessage(error.response.data.message)
                })
        },

    },

}
</script>
